import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { NotificationService, NOTIFICATION_DURATIONS, NOTIFICATION_TYPE_ERROR } from 'ui-components/services/notification-service';

import { useBinaryState } from '../../../../hooks/use-binary-state';
import { importProcessRequested } from '../../../../store/csv-import/csv-import.actions';
import { startImport as startImportJob } from '../api';
import { messages } from './use-start-import-messages';

/**
 * @typedef {import('../types/types').StartImportRequest} StartImportRequest
 */

/**
 * @param {string} pusherEvent
 * @param {string} [workflowType]
 * @returns {{
 *  startImport: (request: StartImportRequest, onStart: (request: StartImportRequest) => void, onSuccess: () => void, onFail: (error: Error) => void) => void,
 *  isImportLoading: boolean
 * }}
 */
export const useStartImport = (pusherEvent, workflowType) => {
  const [isImportLoading, startImportLoading, stopImportLoading] = useBinaryState();

  const dispatch = useDispatch();

  /**
   * @param {StartImportRequest} request
   * @param {(request: StartImportRequest) => void} onStart
   * @param {() => void} onSuccess
   * @param {(error: Error) => void} onFail
   * @returns {void}
   */
  const startImport = (request, onStart, onSuccess, onFail) => {
    onStart(request);
    startImportLoading();
    startImportJob(request)
      .then(() => {
        dispatch(
          importProcessRequested({
            jobId: request.jobId,
            importType: request.importType,
            pusherEvent,
            workflowType,
          }),
        );
        onSuccess();
      })
      .catch((error) => {
        NotificationService.showNotification({
          notificationType: NOTIFICATION_TYPE_ERROR,
          title: <FormattedMessage {...messages.errorTitle} />,
          content: <FormattedMessage {...messages.errorContent} />,
          duration: NOTIFICATION_DURATIONS.SHORT,
        });
        onFail(error);
      })
      .finally(stopImportLoading);
  };

  return {
    startImport,
    isImportLoading,
  };
};
